// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1JpHw","title":"ClientReferral_title__1yt_K","itemText":"ClientReferral_itemText__1uG30"};